module.exports = __webpack_public_path__ + "static/media/Add.fe6145a5.svg";